import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import useSelectOptions from '@/hooks/useSelectOptions';
import {
  usePaymentConditionMutate,
  usePaymentsConditionReduced,
} from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.hooks';
import { ListPaymentConditionsQuery } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.types';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListPaymentConditionsQuery;
  queryEnable?: boolean;
};

const PaymentConditionInfiniteSelect: React.FC<Props> = ({
  queryFilter,
  queryEnable = false,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>();
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const paymentConditionList = usePaymentsConditionReduced(
    {
      ...queryFilter,
      active: true,
      rows: 10,
      name: search,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const paymentConditionDetail = usePaymentConditionMutate();

  const options = useSelectOptions({
    list: paymentConditionList,
    detail: paymentConditionDetail,
    selectProps: props,
    labelFormatter: (supplier) => supplier.name,
  });

  return (
    <InfiniteSelect
      fetchNextPage={paymentConditionList.fetchNextPage}
      hasNextPage={paymentConditionList.hasNextPage}
      loading={paymentConditionList.isFetching}
      options={options}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default PaymentConditionInfiniteSelect;
